var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalVehicle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8938 14.0393H31.1372V11.1938C31.1372 9.99532 30.192 9.01963 29.031 9.01963H26.2745V6.17414C26.2745 4.97569 25.3293 4 24.1683 4H7.1062C5.9452 4 5 4.97569 5 6.17414V23.7866C5 24.9851 5.9452 25.9607 7.1062 25.9607H9.86276V28.8062C9.86276 30.0047 10.808 30.9804 11.969 30.9804H14.7255V33.8259C14.7255 35.0243 15.6707 36 16.8317 36H33.8938C35.0548 36 36 35.0243 36 33.8259V16.2134C36 15.0149 35.0548 14.0393 33.8938 14.0393ZM11.969 29.0981C11.814 29.0981 11.6863 28.9664 11.6863 28.8064V11.1939C11.6863 11.0339 11.814 10.9021 11.969 10.9021H29.031C29.186 10.9021 29.3137 11.0339 29.3137 11.1939V14.0394H16.8316C15.6706 14.0394 14.7254 15.0151 14.7254 16.2135V29.0983L11.969 29.0981Z",
    fill: "#EB6732"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVehicle);
export default __webpack_public_path__ + "static/media/totalVehicle.fa0b1e4d30de0be8d5b4d1091420e6e6.svg";
export { ForwardRef as ReactComponent };